"use client";
import * as React from "react";
import { cn } from "@/lib/utils/utils";

export interface PositiveButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

const PositiveButton = React.forwardRef<HTMLButtonElement, PositiveButtonProps>(
  ({ className, children, ...props }, ref) => {
    // children이 여러 개인지 확인하여 flex 레이아웃 적용
    const hasMultipleChildren = React.Children.count(children) > 1;

    return (
      <button
        className={cn(
          "rounded-md py-1 text-sm font-medium shadow-sm transition-colors",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          "disabled:pointer-events-none",
          "bg-zinc-700 text-white hover:bg-zinc-600 disabled:opacity-70",
          "dark:bg-zinc-100 dark:text-black dark:hover:bg-zinc-300 dark:disabled:opacity-70",
          hasMultipleChildren
            ? "flex px-2 flex-row items-center gap-2"
            : "px-4",
          className,
        )}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  },
);
PositiveButton.displayName = "PositiveButton";

export { PositiveButton };
